/* eslint-disable camelcase */

/**
 * Wrapper used to send events and data to Google Tag Manager,
 * which is then used to send tracking data to
 * Google Analytics and other tracking software.
 *
 * All communication is being data via dataLayer:
 * https://developers.google.com/tag-manager/devguide#datalayer
 * This module simply is an abstraction to make it look more, RequireJS like.
 *
 * dataLayer global variable gets set by Google Tag Manager script.
 *
 * It also includes a wrapper to trigger, virtualPageView event, every time
 * Durandal router completes composition of a view. Google tag manager uses that event
 * to send "Virtual Pageview" to Google Analytics, since regular tracking script for
 * Google Analytics, cannot account for SPA transitions.
 *
 */
define('tagmanager',['require','exports','module'],function (require, exports) {
    /**
     * Simple wrapper for dataLayer https://developers.google.com/tag-manager/devguide#datalayer
     */
    function track(dataObject) {
        if (typeof dataObject !== 'object') {
            throw new Error('Tag manager parameter must be an object.');
        }

        if (window.dataLayer) {
            window.dataLayer.push(dataObject);
        }
    }

    exports.track = track;

    /**
     * Wrapper to track Google Analytics Events
     * sends event called `gaEvent` to Google Tag Manager, which uses data provided in
     * data object, to construct an actual Google Analytics event call. This data can also be used form within
     * Google Tag Manager to construct other calls, i.e. a similar call to MixPanel.
     *
     * data could have the following options set, which matches Google Analytics event data:
     * https://developers.google.com/analytics/devguides/collection/analyticsjs/events#overview
     *
     * {
     *  category: 'Some Category' //Required String
     *  action: 'Some Action' //Required String
     *  label: 'Some Label' //Optional String
     *  value: someValue //Optional Number
     * }
     */
    exports.gaEvent = function (data) {
        if (typeof data != 'object') {
            throw new Error('gaEvent requires an object of parameters. i.e. {category: "bar", action: "foo" }');
        }
        if (!data.category || !data.action) {
            throw new Error('Category and Action are required for Google Analytics Event');
        }
        track({
            event: 'gaEvent',
            gaEventData: data
        });
    };
});

